module.exports = __webpack_public_path__ + "static/media/left_disabled.cc54ed71.svg";